import api from './api';

export const listUnits = async () => {
  const res = await api.get('/checklist/unidades');
  return res.data;
};

export const getUnit = async (id) => {
  const res = await api.get(`/checklist/unidades/${id}`);
  return res.data;
};

export const saveUnit = async (data) => {
  if (data.unidade_id) {
    const res = await api.put(`/checklist/unidades/${data.unidade_id}`, data);
    return res.data;
  }

  const res = await api.post('/checklist/unidades', data);
  return res.data;
};

export const deleteUnit = async (id) => {
  await api.delete(`/checklist/unidades/${id}`);
};
